<div class="w-full border-bottom-1 surface-border overflow-x-hidden p-3">
    <!-- Navigation Header -->
    <div class="flex w-full justify-content-between align-items-center mb-3">
        <button class="nav-button" (click)="navigatePrevious()" [disabled]="isPreviousDisabled">
            <i class="pi pi-chevron-left"></i>
        </button>
        <button class="nav-button" (click)="navigateNext()" [disabled]="isNextDisabled">
            <i class="pi pi-chevron-right"></i>
        </button>
    </div>

    <!-- Calendar Grid(s) -->
    <div class="calendar-grids" [ngClass]="{'single-month': calendarMonths.length === 1, 'dual-month': calendarMonths.length === 2}">
        <div *ngFor="let month of calendarMonths" class="flex flex-column">
            <!-- Month Title -->
            <div class="text-center mb-3">
                <span class="text-base font-semibold">{{ month.monthName }}</span>
            </div>

            <!-- Weekday Headers -->
            <div class="calendar-weekdays">
                <div *ngFor="let weekday of getWeekdayHeaders()" class="text-center text-sm text-color-secondary p-2 font-semibold">
                    {{ weekday }}
                </div>
            </div>

            <!-- Calendar Days -->
            <div class="calendar-weeks">
                <div *ngFor="let week of month.weeks" class="calendar-week">
                    <div *ngFor="let day of week"
                         class="calendar-day text-center"
                         [ngClass]="{
                            'other-month': !day.isCurrentMonth,
                            'has-deals': day.hasDeals && day.isCurrentMonth,
                            'selected': day.isSelected && day.isCurrentMonth,
                            'today': day.isToday
                         }"
                         (click)="selectDay(day)">
                        <div class="day-content flex flex-column align-items-center justify-content-center gap-1 p-1 w-full h-full overflow-hidden"
                             [ngClass]="{'selected': day.isSelected && day.isCurrentMonth}">
                            <span *ngIf="day.isCurrentMonth" class="text-sm font-medium">{{ day.dayNumber }}</span>
                            <span *ngIf="day.hasDeals && day.isCurrentMonth && day.lowestPrice" class="day-price">
                                ${{ day.lowestPrice }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
<!-- Selected Deal Display -->
<div *ngIf="selectedDeals.length > 0" class="selected-deal-container">
    <div *ngFor="let deal of selectedDeals; let last = last" class="flex justify-content-between align-items-center p-3 w-full surface-border" [ngClass]="{'border-bottom-1': !last}">
        <div class="flex flex-column gap-1">
            <span class="m-0">{{ deal.airline }}</span>
            <div class="flex align-items-center gap-3 text-sm text-color-secondary">
                <span>
                    <i class="pi pi-calendar mr-1"></i>
                    {{ deal.dates }}
                </span>
                <span *ngIf="deal.numberOfStops === 0">
                    <i class="pi pi-minus mr-1"></i>
                    {{ deal.stops }}
                </span>
                <span *ngIf="deal.numberOfStops !== 0">
                    <i class="pi pi-arrow-right-arrow-left mr-1"></i>
                    {{ deal.stops }}
                </span>
            </div>
        </div>
        <div class="flex flex-column align-items-end justify-content-center">
            <span class="m-0 text-lg font-semibold">${{ deal.price }}</span>
            <button (click)="openBookingModal(deal)" class="flex align-items-center gap-1 cursor-pointer text-sm font-semibold bg-transparent border-none p-0" style="color: #0062D5;">
                Book Deal
                <i class="pi pi-arrow-right text-xs"></i>
            </button>
        </div>
    </div>
</div>
